/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';

/**
 * 
 * @export
 * @interface CreateGlossaryTermDTO
 */
export interface CreateGlossaryTermDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateGlossaryTermDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlossaryTermDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlossaryTermDTO
     */
    imageId?: string;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof CreateGlossaryTermDTO
     */
    links: Array<HTTPLink>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGlossaryTermDTO
     */
    additionalImageIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateGlossaryTermDTO interface.
 */
export function instanceOfCreateGlossaryTermDTO(value: object): value is CreateGlossaryTermDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    return true;
}

export function CreateGlossaryTermDTOFromJSON(json: any): CreateGlossaryTermDTO {
    return CreateGlossaryTermDTOFromJSONTyped(json, false);
}

export function CreateGlossaryTermDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGlossaryTermDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
        'additionalImageIds': json['additionalImageIds'] == null ? undefined : json['additionalImageIds'],
    };
}

export function CreateGlossaryTermDTOToJSON(json: any): CreateGlossaryTermDTO {
    return CreateGlossaryTermDTOToJSONTyped(json, false);
}

export function CreateGlossaryTermDTOToJSONTyped(value?: CreateGlossaryTermDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
        'additionalImageIds': value['additionalImageIds'],
    };
}

